function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as capitalRecordApi from '@/api/capitalRecordApi.js';
import * as storeTagApi from '@/api/storeTagApi.js';
import * as toolUtils from '@/utils/toolUtils.js';
import { categoryApi } from '@/api/store';
import SelectProducts from '../../business/supplier/coupons/selectProducts.vue';
import { excelTemplateApi } from '@/api/componentsApi';
export default {
  components: {
    SelectProducts: SelectProducts
  },
  data: function data() {
    return {
      visibleDrawer: false,
      //是否为展开
      constants: this.$constants,
      listPram: {
        keywords: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      editDialogConfig: {
        visible: false,
        uploadFile: null
      },
      initDetail: {},
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false,
        checkStrictly: true
      },
      merCateList: [],
      selectIds: [],
      selectLists: [],
      excelData: [],
      tagType: 1,
      needRefresh: false
    };
  },
  mounted: function mounted() {
    this.getCategorySelect();
    this.listData = {
      list: [],
      total: 0
    };
  },
  methods: {
    downModal: function () {
      var _downModal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return excelTemplateApi('label_product.xlsx');
            case 1:
              res = _context.v;
              toolUtils.downloadFile(res.fileName, '商品标签批量模版');
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      function downModal() {
        return _downModal.apply(this, arguments);
      }
      return downModal;
    }(),
    // 打开
    initOpen: function initOpen(row) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      this.tagType = type;
      this.initDetail = row || {};
      this.handlerGetListData(this.listPram);
      this.visibleDrawer = true;
    },
    // 关闭
    closeDrawer: function closeDrawer() {
      this.visibleDrawer = false;
      this.needRefresh && this.$emit('doRefresh');
    },
    // 搜索
    handerSearch: function handerSearch() {
      var needRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      this.needRefresh = needRefresh;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    // 列表分页查询
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      storeTagApi.tagProductList(_objectSpread(_objectSpread({}, pram), {}, {
        type: this.tagType,
        labelId: this.initDetail.id
      })).then(function (data) {
        // storeTagApi.tagProductList({...pram, labelId: this.initDetail.id}).then((data) => {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    // 翻页
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    // 翻页
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 多选框选中数据
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectIds = selection.map(function (item) {
        return item.id;
      });
      this.selectLists = selection || [];
    },
    // 商户分类；
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      categoryApi({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 导入修改弹窗
    handlerOpenEdit: function handlerOpenEdit() {
      this.editDialogConfig.visible = true;
      this.excelData = [];
    },
    // 确认导入修改
    submitImport: function submitImport() {
      var _this3 = this;
      if (!this.excelData.length) {
        this.$message.warning('请检查导入文件是否包含商品编码！');
        return;
      }
      ;
      storeTagApi.bindTagByCode({
        id: this.initDetail.id,
        productCodeList: this.excelData,
        type: this.tagType
      }).then(function (res) {
        _this3.$message.success('操作成功！');
        _this3.handerSearch(1);
        _this3.editDialogConfig.visible = false;
      });
    },
    // 批量移除
    batchRemove: function batchRemove(removeIds) {
      var _this4 = this;
      this.$confirm('移除后数据不能被恢复，确认移除吗！', '确定移除').then(function (result) {
        storeTagApi.deleteTagBind({
          productIds: removeIds,
          id: _this4.initDetail.id,
          type: _this4.tagType
        }).then(function (data) {
          _this4.$message.success('删除数据成功');
          _this4.handerSearch(1);
          _this4.selectIds = [];
          _this4.selectLists = [];
        });
      });
    },
    // 选择商品
    addProducts: function addProducts() {
      this.$refs.selectProductsRef.openInit(this.initDetail.id);
    },
    getSelectProduct: function getSelectProduct(productIds) {
      var _this5 = this;
      storeTagApi.bindTagProduct({
        id: this.initDetail.id,
        productIds: productIds,
        type: this.tagType
      }).then(function (res) {
        _this5.$message.success('操作成功！');
        _this5.handerSearch(1);
      });
    },
    // 上传文件
    onSuccess: function onSuccess(excelData) {
      var results = excelData.results;
      var arr = [];
      results.forEach(function (item, index) {
        if (index !== 0) {
          var values = Object.values(item);
          arr.push({
            id: values[0]
          });
        }
      });
      this.excelData = arr.length && arr.map(function (item) {
        return item.id;
      });
      this.$message.success('上传成功');
    }
  }
};